<template>
  <div class="page">
    <!-- <img src="../assets/404.png" alt="404" srcset=""> -->
    <svg-icon name="nodata"></svg-icon>
    <p>{{ message }}</p>
    <div class="page-button">
      <el-button size="mini">{{$t('components.promptInformation.previouPage')}}({{ countDown }}s) </el-button> <el-button size="mini" @click="goHome()"> {{$t('components.promptInformation.backHome')}} </el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'error',
  data() {
    return {
      message: '',
      countDown: 10, // 页面上显示的倒计时数字
      timerThree: null, // 倒计时的对象
    }
  },
  created() {
    this.message = this.$route.query.msg
    this.goBack()
  },
  methods: {
    goBack() {
      //   this.$router.back()
      const TIME_COUNT = 3 // 3s的倒计时变量
      if (!this.timerThree) {
        // 没有倒计时在执行
        this.countDown = TIME_COUNT
        this.timerThree = setInterval(() => {
          if (this.countDown > 0 && this.countDown <= TIME_COUNT) {
            this.countDown--
          } else {
            clearInterval(this.timerThree) // 停止循环执行
            this.timerThree = null // 倒计时对象置为null
            this.$router.go(-2)
          }
        }, 1000) // 1s执行一次
      }
    },
    goHome() {
      clearInterval(this.timerThree) // 停止循环执行
      this.$router.push({ name: 'Dashboard' })
    },
  },
  beforeDestroy(){
      clearInterval(this.timerThree) // 停止循环执行
  }
}
</script>

<style lang="scss" scoped>
.page {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .svg-icon {
    height: 40%;
    width: 40%;
    transform: translateY(-30%);
  }
  p {
    margin-top: -50px;
    margin-bottom: 30px;
    font-size: 16px;
  }
  /deep/.page-button .el-button {
    width: 112.6px;
    border: 1px solid $--color-theme !important;
    border-color: $--border-primary-color;
    color: $--color-theme;
  }
  /deep/.page-button .el-button:hover {
    background-color: $--color-theme !important;
    color: #fff !important;
  }
}
</style>